import Rx from 'rxjs';
import { combineEpics } from 'redux-observable';

import { request } from 'core/generalFunctions';
import * as usuariosCasualesActions from 'modules/usuariosCasuales/action';
import * as generalActions from 'modules/general/action';
import * as errorActions from 'modules/error/action';
import * as constAction from 'root/actionConstants';

const { ajax } = Rx.Observable;

export const getByDocEpic = (action$, store) =>
action$.ofType(constAction.USUARIOS_CASUALES_GET_BY_DOCUMENTO)
.throttleTime(500)
.switchMap(action =>
  ajax(request(action))
  .map(response => usuariosCasualesActions.setByDocState(response.result, action.state.i))
  .catch(err => errorActions.request(err, action))
  .startWith(generalActions.loadingbar_show())
  .finally(() => store.dispatch(generalActions.loadingbar_hide()))
);

export default combineEpics(getByDocEpic);



// WEBPACK FOOTER //
// src/modules/usuariosCasuales/epics.js